export default __webpack_public_path__ + "static/media/icon-node-tipo-audio.f1c96ae6.svg";